<script>
  import clsx from "clsx";
  import Badge from "./Badge.svelte";

  export let dark = false;
  export let icon = false;
  export let appearance = "main";
  export let badge = false;
</script>

{#if badge}
  <Badge class="absolute right-0 top-0 z-10 -translate-y-1/2 translate-x-1/2" {badge} />
{/if}
{#if appearance == "ghost"}
  <span aria-hidden="true" class="btn--ghost__bg" />
  <span class={clsx("btn--ghost__text", dark && "btn--ghost__text--dark")} x-ref={icon ? "icon" : null}>
    <slot />
  </span>
{:else}
  <slot />
{/if}
